/*
 * @TagDialog.vue.vue  uwb基站配置
 * @Description
 * @Author CC
 * @Date 2025/09/20
 */
/* HTML */
<template>
	<el-dialog :title="dialogForm.title"
		:visible.sync="dialogForm.dialogFormVisible"
		:close-on-click-modal="false"
		:append-to-body="true"
		custom-class="form-dialog"
		v-dialogDrag class="dialog_title"
		@close="handleDialogClose">
		<json-viewer :value="jsonData" :expand-depth="15" copyable boxed sort theme="my-awesome-json-theme"></json-viewer>
	</el-dialog>
</template>

<script>
	export default {
		/**
		 * @Des 组件名
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		name: "GpsTagLogDialog",

		/**
		 * @Des 组件引用
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		components: {},
		props: {},
		/**
		 * @Des 数据定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		data() {
			return {
				/**
				 * @Des 弹出层属性
				 * @Auth CC
				 * @Date 2025/09/20
				 */
				dialogForm: {
					title: '',
					dialogFormVisible: false,
				},
				jsonData: ''
			}
		},
		created() {},
		mounted() {},
		/**
		 * @Des 方法定义
		 * @Auth CC
		 * @Date 2025/09/20
		 */
		methods: {

			/**
			 * @Des 打开弹出层
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			openDialog(title, data, index) {
				this.dialogForm.title = title;
				this.jsonData = Object.assign({}, data);
        try{
            this.jsonData.contents = JSON.parse(data.contents);
        }catch(e){
        }
				this.dialogForm.dialogFormVisible = true;
			},
			/**
			 * @Des 弹窗关闭
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			handleDialogClose() {
				this.dialogForm.dialogFormVisible = false;
			},

		}
	}
</script>
/* JS */ /* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 90%;
	}
	/deep/ .el-dialog__body {
		padding: 10px;
	}
	/deep/ .condition-form-item .el-form-item__label {
		line-height: 30px;
	}

	/deep/ .condition-form-item .el-form-item__content {
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagLogDialog.vue